import { useMemo } from 'react';
import sanitizeHTML from '../helpers/sanitizeHTML';

/**
 * Custom React Hook to sanitize HTML content.
 *
 * @param {string} dangerousHTML - The HTML content to be sanitized.
 * @param {string[]} allowedTags - Array of allowed HTML tags.
 * @param {Object} allowedAttributes - Object mapping tags to arrays of allowed attributes.
 * @returns {string} - Sanitized HTML content.
 */
const useSanitizedHTML = (dangerousHTML, allowedTags = [], allowedAttributes = {}) => {
  const sanitizedHTML = useMemo(
    () => sanitizeHTML(dangerousHTML, allowedTags, allowedAttributes),
    [dangerousHTML, allowedTags, allowedAttributes]
  );

  return sanitizedHTML;
};

export default useSanitizedHTML;
